import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API } from '../config';
import LoadingSpinner from './LoadingSpinner';

const ActivityLogsComponent = () => {
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchActivities();
  }, []);

  const fetchActivities = async () => {
    try {
      const response = await axios.get(`${API}/logs/activity`);
      setActivities(response.data.activities);
    } catch (error) {
      console.error('Failed to fetch activities:', error);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('es-ES', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getActionLabel = (action) => {
    const labels = {
      'user_registered': 'Usuario registrado',
      'user_login': 'Inicio de sesión',
      'view_wallet_balance': 'Consulta de saldo',
      'money_sent': 'Dinero enviado',
      'money_received': 'Dinero recibido',
      'view_transaction_history': 'Consulta de historial'
    };
    return labels[action] || action;
  };

  const getModuleIcon = (module) => {
    const icons = {
      'users': '👤',
      'wallet': '💰',
      'transactions': '💸',
      'logs': '📋'
    };
    return icons[module] || '🔧';
  };

  if (loading) return <LoadingSpinner />;

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-gray-900">Bitácora CUALAPP</h2>
        <p className="text-gray-600">Registro de todas tus actividades en la plataforma</p>
      </div>

      <div className="bg-white rounded-lg shadow-md overflow-hidden">
        <div className="divide-y divide-gray-200">
          {activities.length === 0 ? (
            <div className="px-6 py-8 text-center text-gray-500">
              No hay actividades registradas
            </div>
          ) : (
            activities.map((activity) => (
              <div key={activity.id} className="px-6 py-4 hover:bg-gray-50">
                <div className="flex items-start space-x-3">
                  <div className="text-2xl">{getModuleIcon(activity.module)}</div>
                  <div className="flex-1">
                    <div className="flex items-center justify-between">
                      <p className="text-sm font-medium text-gray-900">
                        {getActionLabel(activity.action)}
                      </p>
                      <p className="text-xs text-gray-500">
                        {formatDate(activity.timestamp)}
                      </p>
                    </div>
                    <p className="text-xs text-gray-600 capitalize">
                      Módulo: {activity.module}
                    </p>
                    {activity.details && Object.keys(activity.details).length > 0 && (
                      <div className="mt-2 text-xs text-gray-500">
                        {Object.entries(activity.details).map(([key, value]) => (
                          <span key={key} className="mr-3">
                            {key}: {typeof value === 'object' ? JSON.stringify(value) : value}
                          </span>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};



export default ActivityLogsComponent;
